import { useTranslation } from 'react-i18next';

/** Shown while lazy route chunks (layouts, pages) load after refresh or hard navigation. */
export function RouterRootFallback() {
  const { t } = useTranslation('common');
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-dvh flex-col items-center justify-center gap-2 overflow-y-auto bg-bg px-4 text-sm text-fg-muted"
    >
      <div
        className="h-8 w-8 animate-spin rounded-full border-2 border-border-strong border-t-primary"
        aria-hidden
      />
      <span>{t('state.loading')}</span>
    </div>
  );
}
